import React, { useEffect, useRef, useState } from 'react';
import { InputNumber } from 'antd';
import en from 'src/messages/en.json';

const EditInput = ({
  rowIndex,
  colIndex,
  update,
  value,
  step = 0.5,
  disabled = false,
  className = '',
  isTotalInput = false,
  style = {},
  max = 24,
  decimals = true,
}) => {
  const inputEl = useRef(null);
  const [isOverTime, setIsOverTime] = useState(value > 8);
  const [displayValue, setDisplayValue] = useState(value?.toString() ?? '');

  const handleFocus = () => {
    inputEl.current?.select();
  };

  const onChange = (val) => {
    if (val === null || val === undefined) {
      setDisplayValue('');
      update({ target: { value: '' } }, rowIndex, colIndex);

      return;
    }

    const valStr = val.toString();

    setDisplayValue(valStr);

    const numVal = parseFloat(valStr);

    if (!isNaN(numVal)) {
      setIsOverTime(numVal > 8);
      update({ target: { value: numVal } }, rowIndex, colIndex);
    }
  };

  const handleBlur = () => {
    const trimmed = (displayValue ?? '').toString().trim();
    const numVal = parseFloat(trimmed);

    if (trimmed === '' || isNaN(numVal)) {
      setDisplayValue('0');
      setIsOverTime(false);
      update({ target: { value: 0 } }, rowIndex, colIndex);
    } else {
      setIsOverTime(numVal > 8);
    }
  };

  const handleKeyDown = (e) => {
    const { key } = e;

    if (key === 'ArrowDown' || key === 'ArrowUp') {
      e.preventDefault();
      const currentElement = e.target as HTMLInputElement;
      const rowElement = currentElement.closest('.input-row');
      const siblingRow =
        key === 'ArrowDown'
          ? rowElement?.nextElementSibling
          : rowElement?.previousElementSibling;

      if (siblingRow) {
        const inputElements = siblingRow.querySelectorAll('input');
        const currentColIndex = currentElement.getAttribute('data-col-index');

        const targetInput = Array.from(inputElements).find(
          (input) => input.getAttribute('data-col-index') === currentColIndex,
        );

        if (targetInput) {
          targetInput.focus();
        }
      }
    }
  };

  useEffect(() => {
    if (value === 0 && displayValue === '') return;

    setDisplayValue(value?.toString() ?? '');
    setIsOverTime(parseFloat(value) > 8);
  }, [value, displayValue]);
  useEffect(() => {
    if (value > 8) {
      setIsOverTime(true);
    } else {
      setIsOverTime(false);
    }
  }, [value]);

  return (
    <InputNumber
      ref={inputEl}
      placeholder={en.Common.Placeholder.enterNumber}
      value={displayValue === '' ? null : Number(displayValue)}
      onChange={onChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
      readOnly={disabled}
      step={step}
      style={{
        ...(style || {}),
        ...(!isTotalInput && isOverTime ? { border: '2px solid #E09101' } : {}),
        ...(disabled ? { pointerEvents: 'none' } : {}),
      }}
      min={0}
      max={max}
      changeOnWheel
      formatter={(val) => val?.toString() ?? ''}
      precision={decimals ? 2 : 0}
      keyboard={false}
      data-col-index={colIndex}
    />
  );
};

export default EditInput;
